//import $ from 'jquery';
//import 'jquery-validation';

export const svMessages = {
    alphanumeric: "Inga specialtecken, endast bokst�ver.",
    required: "Detta f�lt �r obligatoriskt.",
    remote: "Var sn�ll och �tg�rda detta f�lt.",
    //maxlength: $.validator.format("Du f�r ange h�gst {0} tecken."),
    //minlength: $.validator.format("Du m�ste ange minst {0} siffror."),
    //rangelength: $.validator.format("Ange minst {0} och max {1} tecken."),
    email: "Ange en korrekt e-postadress.",
    url: "Ange en korrekt URL.",
    date: "Ange ett korrekt datum.",
    dateISO: "Ange ett korrekt datum (����-MM-DD).",
    number: "Ange ett korrekt nummer.",
    digits: "Ange endast siffror.",
    equalTo: "Ange samma v�rde igen.",
    //range: $.validator.format("Ange ett v�rde mellan {0} och {1}."),
    //max: $.validator.format("Ange ett v�rde som �r mindre eller lika med {0}."),
    //min: $.validator.format("Ange ett v�rde som �r st�rre eller lika med {0}."),
    creditcard: "Ange ett korrekt kreditkortsnummer.",
    pattern: "Ogiltigt format.",
    alphanumericRestricted: "Inga specialtecken, endast bokst�ver.",
    reviewrange: "Sn�lla ge oss en po�ng",
    phoneNumber: "Var v�nlig och sl� in ett giltigt telefonnummer",
    noSpace: "Please remove any whitespace",
    passwordCheck: "Password does not meet requirements. Please use at least one upper-case character, one lower-case character, and one number."
} as const;